import { Flex } from '@sequencehq/core-components'
import { FC } from 'react'

import { useAtom, useAtomValue } from 'jotai'
import { EmailForm } from '../../../components'
import {
  REMINDER_NODE_LINK_TEMPLATE_VARIABLES,
  REMINDER_NODE_RECIPIENT_TEMPLATE_VARIABLES,
  REMINDER_NODE_TEMPLATE_VARIABLES
} from '../../../reminder.constants'
import {
  bccAtom,
  bodyAtom,
  ccAtom,
  showValidationErrorsAtom,
  subjectAtom,
  toAtom,
  validationErrorsAtom
} from './emailReview.atoms'

export const EmailReviewForm: FC = () => {
  const [to, setTo] = useAtom(toAtom)
  const [cc, setCc] = useAtom(ccAtom)
  const [bcc, setBcc] = useAtom(bccAtom)
  const [subject, setSubject] = useAtom(subjectAtom)
  const [body, setBody] = useAtom(bodyAtom)
  const showValidationErrors = useAtomValue(showValidationErrorsAtom)
  const validationErrors = useAtomValue(validationErrorsAtom)

  return (
    <Flex
      boxSize="100%"
      paddingX="8px"
      paddingY="4px"
      data-testid="watchtower.reviewEmail.form"
    >
      <EmailForm
        to={to}
        setTo={setTo}
        cc={cc}
        setCc={setCc}
        bcc={bcc}
        setBcc={setBcc}
        subject={subject}
        setSubject={setSubject}
        body={body}
        setBody={setBody}
        bodyHeight="100%"
        recipientVariables={REMINDER_NODE_RECIPIENT_TEMPLATE_VARIABLES}
        subjectVariables={REMINDER_NODE_TEMPLATE_VARIABLES}
        bodyVariables={REMINDER_NODE_TEMPLATE_VARIABLES}
        bodyLinkVariables={REMINDER_NODE_LINK_TEMPLATE_VARIABLES}
        validationErrors={showValidationErrors ? validationErrors : undefined}
      />
    </Flex>
  )
}
